var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-wide',[_c('div',[_c('sub-navbar',{attrs:{"page":"Stock"}})],1),_c('div',[_c('SearchStockItems')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }